import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getPageTrackingData from 'selectors/getPageTrackingData';
import { trackPageEvent } from 'utils/tracking';
import { options } from 'config/reactRedux';

const PageShownTracking = ({ pageTrackingData }) => {
  const { isLoading, data } = pageTrackingData;
  useEffect(() => {
    if (!isLoading) {
      trackPageEvent({ name: 'magazine_page:shown', ...data });
    }
  }, [isLoading, data.page_path]);

  return null;
};

PageShownTracking.propTypes = {
  pageTrackingData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  pageTrackingData: getPageTrackingData(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

export default withRedux(PageShownTracking);
